<template>
  <div ref="chart" class="finance-chart" :style="{ height }" />
</template>

<script>
import * as echarts from 'echarts'

export default {
  name: 'FinanceChart',
  props: {
    option: { type: Object, required: true },
    height: { type: String, default: '320px' }
  },
  data () {
    return { chart: null }
  },
  watch: {
    option () { this.renderChart() }
  },
  mounted () {
    this.chart = echarts.init(this.$refs.chart)
    this.renderChart()
    window.addEventListener('resize', this.resizeChart)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.resizeChart)
    if (this.chart) this.chart.dispose()
  },
  methods: {
    renderChart () {
      if (!this.chart) return
      this.chart.clear()
      this.chart.setOption(this.option || {}, true)
    },
    resizeChart () {
      if (this.chart) this.chart.resize()
    }
  }
}
</script>

<style scoped>
.finance-chart {
  width: 100%;
}
</style>
